import { fetchApi } from '@/lib/utils';

export interface SignedUrlResponse {
  id: string;
  type: string;
  filePath: string;
  url: string;
}

export class UploadService {
  static urls = {
    getSignedUrl(name: string, contentType: string) {
      const search = new URLSearchParams({ name, type: contentType });
      return `/v1/upload/signed-url?${search.toString()}`;
    },
  };

  static async getSignedUrl(name: string, contentType: string): Promise<SignedUrlResponse> {
    const url = this.urls.getSignedUrl(name, contentType);
    return fetchApi<SignedUrlResponse>(url, {
      headers: {
        redirect: 'follow',
        method: 'GET',
      },
    });
  }

  static async uploadFile(file: File): Promise<{ id: string; url: string; statusWs: string }> {
    const { id, url } = await this.getSignedUrl(file.name, file.type);

    const formData = new FormData();
    formData.append('file', file);

    await fetchApi(url, {
      method: 'PUT',
      headers: {
        'content-type': file.type,
      },
      data: file,
    });

    const { statusWs } = await fetchApi<{ statusWs: string }>(`/v1/upload/signed-url/${id}`, {
      method: 'POST',
    });

    return {
      id,
      statusWs,
      url,
    };
  }
}
